import { createSlice } from '@reduxjs/toolkit'
import type { ApplicationSteps, PartialRecord, StepNotification, ThirdPartyNotification } from 'share/types'

import { type RootState } from '..'

type InitialState = {
  wsData: {
    notifications: PartialRecord<ApplicationSteps, StepNotification>
    third_party_notifications: Partial<ThirdPartyNotification['value']>
  }
  message: any
}

const initialState: InitialState = {
  wsData: {
    notifications: {},
    third_party_notifications: {
      flow_id: undefined,
      flow_status: undefined
    }
  },
  message: null
}

const webSocketSlice = createSlice({
  name: 'webSocketSlice',
  initialState,
  reducers: {
    setStepNotificationData(state, { payload }: { payload: StepNotification }) {
      state.wsData.notifications = {
        ...state.wsData.notifications,
        [payload.value.step_type]: payload
      }
    },
    setThirdPartyNotificationData(state, { payload }: { payload: ThirdPartyNotification }) {
      state.wsData.third_party_notifications = {
        ...state.wsData.third_party_notifications,
        ...payload.value
      }
    },
    setServerNotificationData(state, { payload }: { payload: string }) {
      state.message = payload
    },
    removeStepNotificationData(state, { payload }: { payload: ApplicationSteps }) {
      delete state.wsData.notifications[payload]
    },
    removeStepNotificationsData(state, { payload }: { payload: ApplicationSteps[] }) {
      payload.forEach(step => {
        delete state.wsData.notifications[step]
      })
    },
    removeThirdPartyNotificationData(state) {
      state.wsData.third_party_notifications = initialState.wsData.third_party_notifications
    }
  }
})

export const {
  setServerNotificationData,
  setStepNotificationData,
  setThirdPartyNotificationData,
  removeStepNotificationData,
  removeStepNotificationsData,
  removeThirdPartyNotificationData
} = webSocketSlice.actions

export const getNotificationsSelector = (state: RootState) => state.ws.wsData.notifications
export const getThirdPartyNotificationsSelector = (state: RootState) => state.ws.wsData.third_party_notifications

export const getServerNotificationSelector = (state: RootState) => state.ws.message

export const getLastNotificationStepSelector = (state: RootState) => {
  const lastStepName = Object.keys(state.ws.wsData.notifications).pop() as ApplicationSteps | undefined
  if (!lastStepName) return
  return state.ws.wsData.notifications[lastStepName]
}

export default webSocketSlice.reducer
